import { z } from 'zod';
// The responsibility LEVEL enum — the fixed code set a responsibility is defined at
// (ADR-026 §C: scope ⊥ accountability; a responsibility grants no power and no
// visibility). Each level names the entity TYPE a `user_responsibilities.scope_id`
// resolves against once assigned (project → project_id; zone/cluster → integer id as
// text; site/warehouse/vehicle_pool → nanoid; team → team id). The level is chosen at
// CREATE and IMMUTABLE thereafter — changing it would orphan the polymorphic scope_id
// of every assignment already made against the definition.
//
// The array ORDER is the containment hierarchy (project ⊃ zone ⊃ cluster ⊃ site, then
// the anchored kinds) and is load-bearing: it drives the level Select order, the list's
// default ordering, and the level-set checkboxes — never re-sort alphabetically.
//
// ONE source, two surfaces (CONVENTIONS §Schemas / ADR-009):
//   • `responsibilities.level` — define a kind AT a level (managed under reference_data:manage).
//   • role-side `responsibility_levels` — the level-set that delegates ASSIGNING at a level
//     (`users:manage`'s accountability action, the inline narrowing per ADR-026 §E).
//
// `warehouse` / `vehicle_pool` / `team` may name entities whose tables land at a later
// slice (warehouses/vehicle_pools/teams) — defining a responsibility is independent of
// assigning it, so the full set is valid from the catalogue onward (the `warehouse`
// precedent). The DB CHECK chk_responsibilities_level mirrors this list exactly.
export const RESPONSIBILITY_LEVELS = [
    'project',
    'zone',
    'cluster',
    'site',
    'warehouse',
    'vehicle_pool',
    'team',
];
export const ResponsibilityLevelSchema = z.enum(RESPONSIBILITY_LEVELS);
